<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->
          <div class="row mb-2">
            <div class="col-md-12">
              <div
                class="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"
              >
                <div class="dropdown me-2 bg-success">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    ><i class="ti ti-package-export me-2"></i>Import/Export</a
                  >
                  <div class="dropdown-menu dropdown-menu-end">
                    <ul>
                      <li>
                        <a href="#" class="dropdown-item" @click="importModal()"
                          ><i class="ti ti-file-type-xls text-green me-1"></i
                          >Import as Excel
                        </a>
                      </li>
                      <li>
                        <a
                          href="/sample/sample-file.xlsx"
                          class="dropdown-item"
                          download
                          ><i class="ti ti-download text-blue me-1"></i>Download
                          Sample File
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          @click="downloadPhoneExcel"
                        >
                          <i class="ti ti-download text-blue me-1"></i> Export
                          Phone
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <button
                  class="btn btn-primary"
                  @click="goToUrl('/stackholder-create')"
                >
                  <i class="ti ti-square-rounded-plus me-2"></i>Add Stackholder
                </button>
              </div>
            </div>
          </div>

          <div class="card">
            <!-- Search -->
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-md-3 mb-2">
                  <input
                    type="text"
                    v-model="searchQuery"
                    class="form-control"
                    placeholder="Companies..."
                  />
                </div>
                <div class="col-md-3 mb-2">
                  <select v-model="selectedIndustryType" class="form-control">
                    <option value="">Select Industries</option>
                    <option
                      v-for="(industry, index) in industryTypesArr"
                      :key="index"
                      :value="industry?.name"
                    >
                      {{ industry?.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-2">
                  <multiselect
                    v-model="exhibitions"
                    :options="exhibitionsArr"
                    track-by="id"
                    label="name"
                    multiple="true"
                    placeholder="exhibitions"
                  >
                  </multiselect>
                </div>
                <div class="col-md-3 mb-2">
                  <div
                    class="daterange-picker d-flex align-items-center justify-content-center"
                  >
                    <div class="form-sort me-2">
                      <i class="ti ti-calendar"></i>
                      <input
                        type="text"
                        class="form-control date-range bookingrange"
                        ref="dateRangeInput"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <multiselect
                    v-model="employees"
                    :options="employeesArr"
                    track-by="id"
                    label="name"
                    multiple="true"
                    placeholder="Select Employees"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <!-- /Search -->
            <div class="card-body">
              <!-- Countries List -->
              <div v-if="!isLoading" class="table-responsive custom-table">
                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="filteredData"
                  :row-selection="rowSelection"
                  row-key="id"
                  table-layout="fixed"
                >
                  <template #bodyCell="{ column, record }">
                    <!-- Render Action Column -->
                    <template v-if="column.key === 'action'">
                      <div class="dropdown table-action">
                        <a
                          href="#"
                          class="action-icon"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ><i class="fa fa-ellipsis-v"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="
                              userInfo && userInfo?.id == record?.created_by
                            "
                            class="dropdown-item"
                            href="#"
                            @click="goToEditPage(record?.id)"
                          >
                            <i class="ti ti-edit text-blue"></i> Edit
                          </a>

                          <a
                            v-if="
                              userPermissions &&
                              userPermissions.includes('Prospect Delete')
                            "
                            class="dropdown-item"
                            href="#"
                            @click="openDeleteModal(record)"
                            ><i class="ti ti-trash text-danger"></i> Delete</a
                          >
                        </div>
                      </div>
                    </template>

                    <!-- Render Initial Info -->
                    <template v-else-if="column.key === 'initial_info'">
                      <ul class="custom-text-truncation">
                        <li>
                          {{ record?.organization_name }}<br />

                          {{ record?.address }}<br />
                        </li>
                      </ul>
                    </template>
                    <template v-else-if="column.key === 'prospect_exhibitions'">
                      <ul class="custom-text-truncation">
                        <li
                          v-for="(
                            exhibition_item, index
                          ) in record?.exhibitions"
                          :key="index"
                        >
                          {{ exhibition_item?.name }}<br />
                        </li>
                      </ul>
                    </template>
                    <!-- Render Concern Person Info -->
                    <template v-else-if="column.key === 'industry_type'">
                      <ul class="custom-text-truncation">
                        <li>
                          {{ record?.industry?.type }}
                        </li>
                      </ul>
                    </template>
                    <template
                      v-else-if="
                        column.key === 'created_by' && record?.created_by
                      "
                    >
                      <div class="custom-text">{{ record.user?.name }}</div>
                    </template>
                    <template
                      v-else-if="
                        column.key === 'created_at' && record?.created_at
                      "
                    >
                      {{ formatDate(record.created_at) }}
                    </template>
                  </template>
                </a-table>
              </div>

              <!-- Loading indicator -->
              <div v-else>
                <p>Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <stackholder-delete-modal v-if="isShowModal" @refresh="refresh" />
  <stackholder-import-modal v-if="isShowModal" @refresh="refresh" />
</template>

<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapGetters } from "vuex";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Manage Stackholders",
      data: [],
      isLoading: true,
      isEditMode: false,
      isShowModal: false,
      industryTypesArr: [],
      exhibitionsArr: [],
      employeesArr: [],
      searchQuery: "",
      selectedIndustryType: "",
      exhibitions: [],
      employees: [],
      startDate: null,
      endDate: null,
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          width: "10%",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Company Information",
          key: "initial_info",
        },
        {
          title: "Industry Type",
          key: "industry_type",
        },
        {
          title: "Exhibitions",
          key: "prospect_exhibitions",
        },
        {
          title: "Created By",
          key: "created_by",
          width: "15%",
        },
        {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at",
          width: "15%",
          sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        },
        {
          title: "Action",
          key: "action",
          width: "7%",
        },
      ],

      rowSelection: {
        onChange: () => {},
        onSelect: () => {},
        onSelectAll: () => {},
      },
    };
  },
  mounted() {
    this.getCollections();
    this.getIndustryTypes();
    this.getExhibitions();
    this.getEmployees();

    if (this.$refs.dateRangeInput) {
      const start = moment().subtract(6, "days");
      const end = moment();

      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: moment(),
          endDate: moment(),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
          },
        },
        this.booking_range
      );
    }
  },
  computed: {
    ...mapGetters(["userInfo", "userPermissions"]),

    filteredData() {
      return this.data.filter((item) => {
        const matchesSearch = item.organization_name
          ?.toLowerCase()
          .includes(this.searchQuery.toLowerCase());

        const matchesIndustry = this.selectedIndustryType
          ? item.industry?.type === this.selectedIndustryType
          : true;

        // Filter by selected exhibitions
        const matchesExhibitions =
          this.exhibitions.length > 0
            ? item.exhibitions?.some((exhibition) =>
                this.exhibitions.some(
                  (selected) => selected.id === exhibition.id
                )
              )
            : true;

        const matchesEmployees =
          this.employees.length > 0
            ? this.employees.some((employee) => employee.id == item.created_by)
            : true;

        // Convert created_at to a moment object
        const createdAt = item.created_at ? moment(item.created_at) : null;
        const startDate = this.startDate
          ? moment(this.startDate).startOf("day")
          : null;
        const endDate = this.endDate ? moment(this.endDate).endOf("day") : null;

        // Filter by date range
        const matchesDateRange =
          createdAt && startDate && endDate
            ? createdAt.isBetween(startDate, endDate, null, "[]") // [] includes start & end
            : true;

        return (
          matchesSearch &&
          matchesIndustry &&
          matchesExhibitions &&
          matchesDateRange &&
          matchesEmployees
        );
      });
    },
  },
  methods: {
    async downloadPhoneExcel() {
      try {
        const response = await http.post(
          "/download-all-phone",
          {
            data: this.filteredData,
          },
          {
            responseType: "blob",
            headers: {
              Accept: "application/octet-stream",
            },
          }
        );

        let filename = "phone_numbers.csv";

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    booking_range(start, end) {
      this.startDate = start ? start.format("M/D/YYYY") : "";
      this.endDate = end ? end.format("M/D/YYYY") : "";
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        this.industryTypesArr = response.data.contents.map((industry) => ({
          id: industry.id,
          name: industry.type,
        }));
      } catch (error) {
        console.error("Error:", error);
      }
    },

    async getExhibitions() {
      const endpoint = `/exhibitions`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.exhibitionsArr = response.data?.contents.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        //
      }
    },
    async getEmployees() {
      const endpoint = `/employees`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.employeesArr = response.data.contents.map((employee) => {
          return {
            id: employee.id,
            name: employee?.user?.name,
          };
        });
      } catch (error) {
        //
      }
    },
    async getCollections() {
      this.isLoading = true;
      try {
        const response = await http.get("stackholders");
        this.data = response.data.contents;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    refresh() {
      this.isShowModal = false;
      this.getCollections();
    },

    goToUrl(path) {
      this.$router.push(path);
    },
    goToEditPage(recordId) {
      this.$router.push(`/prospect-update/${recordId}`);
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    openDeleteModal(row = "") {
      this.isShowModal = true;
      setTimeout(() => {
        this.$emitter.emit("delete-item-modal", row);
      });
    },
    importModal(row = "") {
      this.isShowModal = true;
      setTimeout(() => {
        this.$emitter.emit("import-item-modal", row);
      });
    },
  },
};
</script>
<style scoped>
.custom-text-truncation {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
  width: 100%; /* Ensure the list takes up the full width */
}

.custom-text-truncation li {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%; /* Prevent content from spilling outside */
}

.custom-text-truncation li span {
  display: inline-block; /* Make sure the span behaves like inline-block */
  max-width: 200px; /* Set a max width to ensure truncation (adjust as needed) */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-text {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%;
}
.form-sort i {
  z-index: unset !important;
}
.dropdown a {
  border: unset !important;
  border-radius: unset !important;
}
</style>
